import React, { useEffect } from 'react';
import '../terms-and-conditions/style';

const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return(
  <div className='pt-8 pb-16 lg:pt-16 lg:pb-24 bg-white privacy-policy'>
    <div className='flex flex-justify-between px-6 mx-auto max-w-screen-xl'>
      <div className='mx-auto w-full max-w-2xl'>
        <h1 className='mt-20 heading-48'>Refund and Cancellation Policy</h1>
        <ol>
          <li className='heading'>User-Initiated Cancellations
            <ol className='child-points'>
              <li>Once a ticket is purchased, cancellations or refund requests initiated by the
                User are not permitted under any circumstances. All ticket sales are final, and
                Users cannot cancel their tickets or request a refund for any reason unless
                specified otherwise under TMT’s terms and conditions or related policies. Users
                are only permitted to utilize other services as provided on the Website.</li>
            </ol>
          </li>
          <li className='heading'>Event Cancellation by Organizers
            <ol className='child-points'>
              <li>
                In the event that the organizers cancel the event, refunds will be only
                processed according to the payment method used for the original ticket purchase
                or as may be determined by TMT under its sole discretion.
              </li>
              <li>
                It is acknowledged and accepted by the User(s) that TMT shall reimburse
                the final amount (post deductions of any payment gateway charges, bank
                transaction fees, or any other applicable charges) upon the cancellation of the
                event by the organizers. Refunds shall only be processed in the event that the
                organizers cancel the event and under no other circumstances.
              </li>
              <li>
                Promotional and discounted tickets may be offered under unique
                conditions and may be strictly non-refundable and non-exchangeable. By
                purchasing a promotional or discounted ticket, you acknowledge and agree to
                these exclusive terms and may waive any right to request a refund, exchange, or
                modification of the ticket under any circumstances, except as mentioned by the
                Event Organiser. It is notified that upon utilization of the promotional or
                discounted ticket or the User could not utilize it due to personal circumstances,
                TMT shall not be obligated to reissue, replace, or refund the ticket. All such
                tickets are sold on an &quot;as-is&quot; basis by the Event Organizer and, once purchased,
                are fully under the control and responsibility of the User and under the terms and
                conditions of the Event Organizer.
              </li>
              <li>
                <strong>Postponement, Rescheduling, or Relocation:</strong> Should the event be
                postponed, rescheduled, or relocated, all purchased tickets, including any
                associated add-ons or upgrades (such as VIP experiences, parking passes or any
                other upgradations), will remain valid for the rescheduled date or venue without
                requiring further action on your part. Refunds in these cases shall not be
                processed. In the event that a rescheduled event is subsequently canceled by the
                Event Organizer, refunds will be administered as per the prevailing terms and
                conditions as outlined herein, and no claim or dispute shall be raised against TMT
                in relation to such cancellations.
              </li>
              <li>
                Users acknowledge that the purchase of tickets or additional event-related
                services (including, but not limited to, parking passes, VIP access, or exclusive
                upgrades) post happening of the event shall not be eligible for a partial refund on
                unused portions of their purchase of the ticket.
              </li>
              <li>
                TMT does not assume any responsibility for expenses incurred by ticket
                holders who are unable to attend due to schedule changes. The decision to grant
                refunds for postponed or rescheduled events lies exclusively with the Event
                Organizer and is subject to their policies and procedures.
              </li>
              <li>
                It is acknowledged and accepted by the Users that denial of entry and non-
                refundable situations; admission to the event and the right to refuse entry remain
                entirely at the discretion of the Event Organizer. The Event Organizer may deny
                admission or remove any attendee who does not comply with applicable rules,
                terms, or conduct policies, or for any reason deemed necessary. Users are strongly
                advised to review and comply with all Event Organizer policies prior to the event
                to avoid any issues that may result in ticket cancellation or denial of entry. Except
                in cases of formal event cancellation, refunds will not be processed under any
                circumstances, including denial of entry or removal from the event. A ticket
                represents a revocable license, and in instances of breach, cancellation, or denial,
                no entitlement to a refund exists.
              </li>
            </ol>
          </li>
          <li className='heading'>Risk of Loss
            <ol className='child-points'>
              <li>In cases where you do not receive an Order Confirmation after submitting
                payment information, or if you experience an error message or service
                interruption during the transaction process, it is solely your responsibility to
                confirm the status of your order via your account dashboard or by contacting our
                or Event Organiser’s (as may be applicable) customer support team. The onus of
                verifying successful order placement rests exclusively with the User, as TMT may
                not be aware of individual transactional issues related to specific accounts,
                devices, or network disruptions. TMT disclaims all liability for any monetary or
                consequential losses that may result from incomplete, interrupted, or erroneous
                transactions, whether arising from technical errors, connectivity issues, or
                unforeseen service disruptions. Under the circumstances described herein, a
                refund may not be issued. However, if you have any questions or need further
                assistance, please feel free to reach out to our customer support team for
                clarification or support.
              </li>
                <li>
                  In the event of a pricing discrepancy, or an unintended sale—whether
                  caused by processing, errors in the displayed pricing, unauthorized access before
                  the scheduled on-sale date, or other transactional anomalies—TMT retains the
                  exclusive right to cancel the ticket or order and refund the amount initially paid.
                  This policy applies irrespective of whether the error originated from human
                  oversight, system malfunction, or automated inaccuracies. If, by error, a refund is
                  processed in an amount exceeding the original payment, TMT reserves the right
                  to recover the excess by debiting the original payment method. Additionally,
                  TMT reserves the right to dispute any unwarranted chargeback requests and
                  recover funds in cases where the chargeback is determined to be invalid or
                  unjustified under applicable rules and policies.</li>
              <li>Refunds will not be issued for issues unrelated to the event, including, but
                  not limited to, travel, accommodation, or any third-party expenses incurred by the
                  user in connection with attending the event. Users acknowledge that TMT is not
                  liable for any additional costs or losses arising from circumstances outside of
                  event cancellation, rescheduling, or relocation. Our liability is strictly limited to
                  the refund of the original ticket price (where applicable and in accordance with
                  these terms) and does not extend to incidental or consequential costs that may
                  arise from your anticipation of attending the event. By purchasing a ticket, you
                  acknowledge and accept that any such arrangements or expenses are made at your
                  own risk, with no entitlement to compensation in the event of changes to the event
                  schedule and as per the terms and conditions enumerated herein.</li>
              <li>Users acknowledge and agree that TMT will not be responsible or liable
                for any losses or costs incurred due to errors in pricing, early sale availability, or
                  other issues.
                </li>
            </ol>
          </li>
          <li className='heading'>Refund Process
            <ol className='child-points'>
              <li>Refunds, where applicable, will be processed within 7 to 10 business days
after the event cancellation is officially announced and notified by the event
organizers. The refund will be credited to the original payment method used for
the ticket purchase.
              </li>
              <li>By proceeding with a ticket purchase, the User agrees to all the terms
outlined in this Refund and Cancellation Policy along with the other policies.
                </li>
                <li>How Secure is the Information shared by you?
            Once a ticket order has been canceled and the refund has been issued, the
decision will be final. No further claims related to the cancellation, pricing error,
or refund discrepancies will be entertained. TMT retains the right to terminate or
modify any order, and TMT’s determination on the matter will be conclusive and
binding.
          </li>
            </ol>
          </li>
          
          
          
        </ol>
      </div>
    </div>
  </div>
);
};

export default RefundPolicy;